import {combineReducers} from 'redux';
import dashboardReducer from './dashboardReducer';
import loginReducer from './loginReducer';
import analyticsReducer from './analyticsReducer';
import confirmPassReducer from './confirmReducer';
import addEmpReducer from './EmpReducer';
import accessCardsReducer from './accessCardsReducer';
import blocklistReducer from './blocklistReducer';

const rootReducers = combineReducers({
  dashboardReducer,
  loginReducer,
  analyticsReducer,
  confirmPassReducer,
  addEmpReducer,
  accessCardsReducer,
  blocklistReducer
})
export default rootReducers;
